import { DateTime } from "luxon";
import { CSRService } from "./CSRService";
import { Worker } from "../models/Worker";

/**
 * Service for manipulation workers from the API
 */
export class WorkerService extends CSRService {
    public constructor() {
        super();
    }

    /**
     * Fetches workers from the API
     * @param city - The city to filter workers by
     * @param date - The date to filter workers by
     * @returns A list of jobs
     */
    public fetchWorkersAsync = async (city: string, date?: string): Promise<Worker[]> => {
        const params = new URLSearchParams();
        if (city) {
            params.append("warehouse", city);
        }
        if (date) {
            params.append("date_requested", date ? DateTime.fromISO(date).toFormat("yyyy-MM-dd") : "");
        }

        // Fetch job data
        const workerResponse = await WorkerService.axiosInstance.get<Worker[]>(`/api/workers?${params.toString()}`);
        return workerResponse.data ?? [];
    };

    /**
     * Exports workers to CSV format
     * @param city - The city to filter workers by
     * @param archived - Whether to include archived workers
     */
    public exportWorkersToCSV = async (city: string, archived = false): Promise<void> => {
        const params = new URLSearchParams();
        if (city) {
            params.append("warehouse", city);
        }
        params.append("archived", archived.toString());

        const response = await WorkerService.axiosInstance.get(`/api/workers/export?${params.toString()}`, {
            responseType: "blob",
        });

        // Create a download link and trigger it
        const blob = new Blob([response.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `workers_export_${DateTime.now().toFormat("yyyyMMdd_HHmmss")}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };
}

export const workerService = new WorkerService();
